var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendUpward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66526 4.16016C7.75687 3.95391 7.71347 3.71484 7.55437 3.55078L4.2758 0.175781C4.16731 0.0632812 4.01544 0 3.85633 0C3.69723 0 3.54535 0.0632812 3.43687 0.175781L0.158296 3.55078C-0.000810767 3.71484 -0.0442036 3.95391 0.0474035 4.16016C0.139011 4.36641 0.346332 4.5 0.577761 4.5H2.31348V11.25C2.31348 11.6648 2.65821 12 3.0849 12H4.62776C5.05446 12 5.39919 11.6648 5.39919 11.25V4.5H7.1349C7.36633 4.5 7.57365 4.36641 7.66526 4.16016Z",
    fill: "#48C80C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUpward);
export default __webpack_public_path__ + "static/media/trend-upward.661c11f0738fce00670189f89c5f5d19.svg";
export { ForwardRef as ReactComponent };